<template>
    <v-autocomplete
        v-model="internalModel"
        :items="organizationsWithSelectAll"
        append-icon=""
        item-text="name"
        item-value="id"
        multiple
        chips
        deletable-chips
        solo
        hide-details
        clear-icon="$vuetify.icons.clear"
        clearable
        :no-data-text="$t('Не найдено подходящих записей')"
        :label="$t('Введите название организации')"
        class="study-card--autocomplete input"
        :menu-props="{ contentClass: 'custom-dropdown-class' }"
    >
        <template #item="{ item, on, attrs }" @click.stop="onItemClick(item)">
            <div
                class="custom-item"
                v-bind="attrs"
                @click.stop="onItemClick(item)"
            >
                <!-- Чекбокс для "Все организации" -->
                <v-checkbox
                    v-if="item.id === selectAllId"
                    :input-value="isAllSelected"
                    hide-details
                    class="checkbox__custom"
                    color="#e2173d"
                    @click.stop="toggleSelectAll"
                />
                <!-- Чекбокс для остальных элементов -->
                <v-checkbox
                    v-else
                    :input-value="internalModel.includes(item.id)"
                    hide-details
                    class="checkbox__custom"
                    color="#e2173d"
                />
                <!-- Текст элемента -->
                <span :class="{ first: item.id === selectAllId }">{{ item.name }}</span>
            </div>
        </template>
        <template #append>
            <v-icon aria-hidden="true" translate="no">
              expand_more
            </v-icon>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
  name : 'AutocompleteWithSelectAll',
  props: {
    model: {
      type    : Array,
      required: true,
    },
    organizations: {
      type    : Array,
      required: true,
    },
    selectAllId: {
      type   : String,
      default: 'select_all',
    },
  },
  data() {
    return {
      internalModel: [...this.model], // Локальная копия модели
    };
  },
  computed: {
    organizationsWithSelectAll() {
      return [
        {
          id  : this.selectAllId,
          name: this.$t(`Все организации (${this.organizations.length})`),
        },
        ...this.organizations,
      ];
    },
    isAllSelected() {
      const allIds = this.organizations.map((org) => org.id);
      return allIds.every((id) => this.internalModel.includes(id));
    },
  },
  watch: {
    internalModel(newVal) {
      console.log(newVal);

      this.$emit('update:model', newVal); // Передаем изменения родителю
    },
    // model(newVal) {
    //   this.internalModel = [...newVal];
    // },
  },
  methods: {
    toggleSelectAll() {
      const allIds = this.organizations.map((org) => org.id);
      if (this.isAllSelected) {
        this.internalModel = [];
      } else {
        this.internalModel = [...allIds];
      }
      this.$emit('update:model', this.internalModel);
    },
    onItemClick(item) {
      if (item.id === this.selectAllId) {
        // Блокируем добавление "Все организации" в список выбранных
        this.toggleSelectAll();
      } else {
        // Добавляем или убираем из выбора обычный пункт
        this.toggleItem(item.id);
      }
    },
    toggleItem(itemId) {
      if (this.internalModel.includes(itemId)) {
        this.internalModel = this.internalModel.filter((id) => id !== itemId);
      } else {
        this.internalModel = [...this.internalModel, itemId];
      }
      this.$emit('update:model', this.internalModel);
    },
  },
};
</script>
<style lang="less">
@import url("../../../less/variables");

.study-card {


    &--autocomplete {
        .v-input__control .v-select__slot .v-select__selections input {
            display: block;
            position: static;
            padding-left: 0;
        }

        .v-chip .v-chip__content {
            white-space: wrap;
        }

        .v-chip .v-chip__content {
            //height: 4rem;
        }

        .v-select .v-chip {
            flex: 1 1 auto;
        }

        &.v-input--is-label-active .v-select__slot {
            max-height: 10rem;
            overflow-y: scroll;
            overflow-x: hidden;
            flex-wrap: wrap;
        }
    }

    .v-select .v-input__icon .v-icon.material-icons {
        font-size: 1.75rem;
        width: 1.75rem;
        height: 1.75rem;
        color: @main-color;

        &:hover {
            color: @font-color;
        }
    }
}

.custom-dropdown-class {

    .v-select-list.v-card div[role="listitem"] .v-list__tile--link {
        //flex-direction: row-reverse;
        .custom-item{
            display: flex;
            gap: 0.75rem;
            width: 100%;
            height: 100%;
            align-items: center;

            .checkbox__custom {
                flex: 0 1 auto;
            }

        }
    }

    .v-select-list.v-card
    div[role="listitem"]:not(:first-child)
    .v-list__tile__action {
        display: block;
    }

    .v-select-list.v-card
    div[role="listitem"]
    .v-input--selection-controls__input {
        margin-left: 0;
    }

    .v-list__tile__action {
        min-width: 2.5rem;
    }
}
</style>
